/**
 * Notification Service API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CollarLog { 
    idData?: number;
    insertTs?: string;
    rawMessageId?: number;
    scts?: string;
    acquisitionTime?: string;
    idDevice?: number;
    idSensor?: number;
    originCode?: CollarLog.OriginCodeEnum;
    dataUploadSource?: CollarLog.DataUploadSourceEnum;
    extendedMessageType?: CollarLog.ExtendedMessageTypeEnum;
    value?: number;
    logType?: CollarLog.LogTypeEnum;
}
export namespace CollarLog {
    export const OriginCodeEnum = {
        Globalstar: 'GLOBALSTAR',
        Iridium: 'IRIDIUM',
        GsmSms: 'GSM_SMS',
        GsmFtp: 'GSM_FTP',
        Terminal: 'TERMINAL',
        Collar: 'COLLAR',
        NbIot: 'NB_IOT',
        IridiumEmail: 'IRIDIUM_EMAIL'
    } as const;
    export type OriginCodeEnum = typeof OriginCodeEnum[keyof typeof OriginCodeEnum];
    export const DataUploadSourceEnum = {
        Provider: 'PROVIDER',
        Gdx: 'GDX',
        HttpUpload: 'HTTP_UPLOAD'
    } as const;
    export type DataUploadSourceEnum = typeof DataUploadSourceEnum[keyof typeof DataUploadSourceEnum];
    export const ExtendedMessageTypeEnum = {
        NoContact: 'NO_CONTACT',
        Mortality: 'MORTALITY',
        Status: 'STATUS',
        Null: 'NULL',
        Expelled: 'EXPELLED'
    } as const;
    export type ExtendedMessageTypeEnum = typeof ExtendedMessageTypeEnum[keyof typeof ExtendedMessageTypeEnum];
    export const LogTypeEnum = {
        TransmissionLog: 'TRANSMISSION_LOG',
        SystemLog: 'SYSTEM_LOG'
    } as const;
    export type LogTypeEnum = typeof LogTypeEnum[keyof typeof LogTypeEnum];
}


export type LogTypeEnum = typeof CollarLog.LogTypeEnum[keyof typeof CollarLog.LogTypeEnum];
